import React from "react";
import { Form, Input } from "antd";

const CustomInputComponent = props => {
  return (
    <Form.Item label={props.label}>
      <Input
        type={props.type ? props.type : "text"}
        {...props.field}
        {...props}
      />
    </Form.Item>
  );
};

export default CustomInputComponent;
